var map = {
	"./ICBC银行.jpg": "V5L7",
	"./OPPO图标.jpg": "aRTq",
	"./VIVO图标.jpg": "ne4e",
	"./banner1.jpg": "nTyu",
	"./banner2信用创造价值.jpg": "Xh36",
	"./banner3资金安全.jpg": "j+Id",
	"./banner4-反欺诈.jpg": "HSYd",
	"./loan-credit-issues-h5-dev.png": "EHAj",
	"./loan-credit-issues-h5-prj.png": "rgyF",
	"./loan-credit-issues-h5.longxie.net.png": "hCYK",
	"./产品介绍页.jpg": "H6mJ",
	"./信息1.png": "pMeI",
	"./信息2.png": "ktWc",
	"./信息3.png": "b0wg",
	"./信息4.png": "GT5h",
	"./信息5.png": "KTd7",
	"./信息6.png": "LE71",
	"./信息披露.jpg": "3cGh",
	"./公司1.jpg": "Xl2C",
	"./公司10.jpg": "2jlQ",
	"./公司11.jpg": "0Uqx",
	"./公司12.jpg": "rdv3",
	"./公司13.jpg": "Knbs",
	"./公司14.jpg": "KC9T",
	"./公司15.jpg": "jkhg",
	"./公司16.jpg": "0jYw",
	"./公司17.jpg": "I2Ln",
	"./公司18.jpg": "/knA",
	"./公司19.jpg": "1iEo",
	"./公司2.jpg": "6YpI",
	"./公司3.jpg": "Brxj",
	"./公司4.jpg": "fLM3",
	"./公司5.jpg": "v3ZR",
	"./公司6.jpg": "k5+m",
	"./公司7.jpg": "dX4u",
	"./公司8.jpg": "zTvC",
	"./公司9.jpg": "B352",
	"./关于隆携.jpg": "+5Ii",
	"./十不准.jpg": "21+2",
	"./咨询投诉.jpg": "Rerb",
	"./微信二维码.jpg": "uLFy",
	"./新闻资讯.jpg": "Yj6n",
	"./民生银行.jpg": "M+z1",
	"./浦发银行.jpg": "QtBn",
	"./箭头.png": "ODIH",
	"./组织架构.png": "70Zh",
	"./股权架构.png": "yWe6",
	"./警徽.jpg": "Mp2Y",
	"./隆携logo.png": "lXbO"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 1